var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",staticClass:"navigation-wrapper is-hidden-print"})}
var staticRenderFns = []

export { render, staticRenderFns }